import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function SolutionsFailSection() {
  const reasons = ['Las "Date Nights" fallan porque pasas toda la cena hablando de los niños o revisando el monitor.', 'Intentar forzar el sexo a las 11 PM solo genera frustración cuando uno de los dos se queda dormido a los dos minutos.', 'Esperar a que "los niños crezcan" para reconectar es una sentencia de muerte para la intimidad a largo plazo.', 'Los consejos genéricos de "vayan a un hotel" no funcionan cuando no tienes ni el dinero, ni la energía, ni con quién dejar a los niños.'];
  return <section className="px-6 py-10 bg-brand-light/5" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-center text-brand-light mb-6" data-id="element-142">
          Por qué lo que has intentado{' '}
          <span className="text-brand-accent italic" data-id="element-143">no funciona</span>
        </motion.h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-144">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 rounded-xl bg-brand-dark border border-brand-light/10" data-id="element-145">
              <div className="mt-1 bg-brand-accent/20 p-1.5 rounded-full shrink-0" data-id="element-146">
                <X className="w-5 h-5 text-brand-accent" data-id="element-147" />
              </div>
              <p className="text-brand-light/80 leading-relaxed" data-id="element-148">{reason}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}